import { gsap } from 'gsap';

function twoImagesGallerySetup(el) {
  const wrappers = [...el.querySelectorAll('.two-images-gallery__img-wrap')]
  const images = [...el.querySelectorAll('img')];

  gsap.set(images, { scale: 1.2 });
  gsap.set(wrappers, { autoAlpha: 0 });
}

function twoImagesGalleryEnter(el) {
  const wrappers = [...el.querySelectorAll('.two-images-gallery__img-wrap')]
  const images = [...el.querySelectorAll('img')];

  const tl = gsap.timeline({ defaults: { duration: 1.2, ease: 'power2.out' }});
  tl.to(wrappers, { autoAlpha: 1 }, 0);
  tl.to(images, { scale: 1 }, 0);
}

export { twoImagesGallerySetup, twoImagesGalleryEnter };